/**
 * Resolve therapy-service-type codes → human-readable episode names for UI display.
 *
 * Sources (in order): admin catalog (HealthcareService episode types), static PRD
 * defaults, then title-cased slug fallback.
 */
import { THERAPY_SERVICE_TYPE_DISPLAY } from './serviceRequestFhirConstants';

let catalogLabels: Readonly<Record<string, string>> = {};

/** Sync labels from the episode-of-care type catalog (HealthcareService). */
export function setEpisodeTypeCatalogLabels(labels: Record<string, string>): void {
  catalogLabels = labels;
}

function humanizeTherapyServiceTypeSlug(code: string): string {
  return code
    .trim()
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

/** Display name for a therapy-service-type code (never returns the raw slug when avoidable). */
export function resolveTherapyServiceTypeLabel(code: string | undefined): string {
  const normalized = code?.trim();
  if (!normalized) return 'Episode of Care';
  if (catalogLabels[normalized]) return catalogLabels[normalized];
  if (THERAPY_SERVICE_TYPE_DISPLAY[normalized]) return THERAPY_SERVICE_TYPE_DISPLAY[normalized];
  return humanizeTherapyServiceTypeSlug(normalized);
}
